export default {
  CREATED_ON: `Créée le {{ date }} par {{ name }}`,
  APPROVED_ON: `Approuvée le {{ date }} par {{ name }}`,
  ACKNOWLEDGED_ON: `Marquée comme reçue le {{ date }} par {{ name }}`,
  JUSTIFIED_ON: `Marquée comme justifiée le {{ date }} par {{ name }}`,
  UNJUSTIFIED_ON: `Marquée comme non justifiée le {{ date }} par {{ name }}`,
  REFUSED_ON: `Refusée le {{ date }} par {{ name }}`,
  CANCELLED_ON: `Annulée le {{ date }} par {{ name }}`,
  MISSING_DATE: `Date manquante`
}
